export const environment = {
	backendUrl: "https://api.teampeps.fr/api/v1",
	minioBaseUrl: "https://minio-s3.teampeps.fr/",
	siteUrl: "https://teampeps.fr",
	production: true,
vapidPublicKey: "BDsBx41yf_hKdYWi3BMS01akBPNCw_Qcqq7lqqmdl-5bgC9GCVDnixnqVW2wH-8liin3DgKdywiQueO1kkjf-hA",
	notificationsSubscriptionUrl: "https://eventsub.teampeps.fr/api/v1/notifications",
	wsUrl: "wss://api.teampeps.fr/api/ws",
	gaId: "G-3CER7HEDVZ",
};
